import { render, staticRenderFns } from "./AltaClientes.vue?vue&type=template&id=506ac32b&scoped=true&"
import script from "./AltaClientes.vue?vue&type=script&lang=js&"
export * from "./AltaClientes.vue?vue&type=script&lang=js&"
import style0 from "./AltaClientes.vue?vue&type=style&index=0&id=506ac32b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ac32b",
  null
  
)

export default component.exports